import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import CardHeader from "@commons/businesscardHeader";
import Column from "@components/column";
import Fields from "@components/fields";
import Wrapper from "@components/wrapper";
import Button from "@components/button";
import { toast } from "react-toastify";
import generalSettings from "@apis/generalSettings";

const Reward = () => {
  const [initialValues, setInitialValues] = useState({
    "reward-percent": "",
  });
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState<any>(null);

  const fetchRewardSettings = async () => {
    try {
      const res = await generalSettings.getByKey({
        state: "reward",
        id: "reward-setting", // Changed to match your API key
        showErr: false,
      });
      if (res) {
        console.log("Reward settings response:", res);
        setInitialValues({
          "reward-percent": res.value?.toString() || "", // Value is directly on res
        });
        setExist(res);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchRewardSettings();
  }, []);

  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      const payload = {
        key: "reward-setting", // Match the API key
        value: values["reward-percent"] || 0, // Value as number
      };

      if (exist?.id) {
        await generalSettings.update({
          state: "reward",
          data: payload,
          id: exist.id,
        });
        toast.success("Reward settings updated successfully!");
      } else {
        await generalSettings.create({ state: "reward", data: payload });
        toast.success("Reward settings saved successfully!");
      }

      fetchRewardSettings();
    } catch (err) {
      console.error(err);
      toast.error("Failed to update reward settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ values }) => (
        <Form>
          <CardHeader title="Zedfo Reward Setting" />
          <Wrapper>
            <Column>
              <Fields.Input
                name="reward-percent"
                label="Rewards % on Order"
                placeholder="2"
                type="number"
              />

              <div style={{ marginTop: 16, textAlign: "right" }}>
                <Button
                  title={exist ? "Update" : "Save"}
                  type="submit"
                  loading={loading}
                  justify="end"
                />
              </div>
            </Column>
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default Reward;
